import { useQuery } from "@tanstack/react-query";
import { boronClient } from "../../../api";
import { createError } from "../../../errors";
import { paths } from "../../../lib/api/v1";

export type StudentFollowPromptInterface =
  paths["/api/v1/sections/{section_id}/student_follow_prompt"]["get"]["responses"]["200"]["content"]["application/json"];

const path = "/api/v1/sections/{section_id}/student_follow_prompt" as const;

export const buildStudentFollowPromptQueryKey = (sectionId: string) => [
  path,
  sectionId,
];

export const useFetchStudentFollowPrompt = ({
  sectionId,
}: {
  sectionId: string;
}) => {
  return useQuery<StudentFollowPromptInterface>({
    queryKey: buildStudentFollowPromptQueryKey(sectionId),
    queryFn: async () => {
      const { response, data } = await boronClient.GET(path, {
        params: { path: { section_id: sectionId } },
      });
      if (response.ok && data) {
        return data;
      }
      throw await createError(response);
    },
  });
};
